function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { Tab } from 'react-bootstrap';
import app from 'srcJs/App';

var FaqContent = function FaqContent(_ref) {
  var faq = _ref.faq,
      hide = _ref.hide;

  if (!faq) {
    return null;
  }

  var menuItems = faq.map(function (menuItem) {
    return /*#__PURE__*/React.createElement("li", {
      className: "menu-panel-section",
      key: menuItem.label
    }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
      className: "menu-panel-link container container-lg-fluid",
      onClick: function onClick() {
        hide();
      }
    })));
  });
  return /*#__PURE__*/React.createElement(Tab.Pane, {
    eventKey: "faq"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled mb-0"
  }, /*#__PURE__*/React.createElement("li", {
    className: "menu-panel-section"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-panel-link py-12p container container-lg-fluid fs-22"
  }, app.tForReact('base_menu', 'FAQ'))), menuItems));
};

export { FaqContent };